import api from '../api';

export async function getSelectedAdditionalsGroupsByGroup(companyId, groupId) {
  try {
    if (!companyId || !groupId)
      throw new Error('companyId and groupId must be provided');

    const { data } = await api.get(
      `/grupo-adicionais/listar/${companyId}/${groupId}`,
    );

    return data;
  } catch (error) {
    console.log(error);

    return [];
  }
}
